import { gql } from '@apollo/client/core';

export const ADD_EMPLOYER = gql`
  mutation RequestCorporateUpgrade($workEmail: String!, $source: String!, $employerSlug: String, $employerName: String) {
    requestCorporateUpgrade(workEmail: $workEmail, source: $source, employerSlug: $employerSlug, employerName: $employerName) {
      ticketId
    }
  }
`;
